import { useMemo } from 'react'
import type { ProjectDocument } from '@/lib/db/rxdb/schemas/project'
import { useProjects as useProjectsRxDB } from '@/lib/db/rxdb/hooks'
import useLoginStore from '@/store/LoginStore'

export function useProjects() {
  const workspaceId = useLoginStore((state) => state.workspaceId)

  // Subscribe to projects
  const { projects: allProjects, isLoading } = useProjectsRxDB({
    isDeleted: false,
  })

  const projects = useMemo<Array<ProjectDocument>>(() => {
    return allProjects.filter((project) => {
      if (workspaceId && project.envId !== workspaceId) {
        return false
      }

      return true
    })
  }, [allProjects, workspaceId])

  const defaultProject = useMemo<ProjectDocument | null>(() => {
    // Return null to default to Inbox when no default project is set
    return null
  }, [projects])

  return {
    projects,
    defaultProject,
    isLoading,
  }
}
